import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import CarePeriodService from '@/services/CarePeriodService';
import type { CarePeriod } from '@/services/CarePeriodService';
import { CARE_PERIOD_KEYS } from './keys';

export function useProgramPeriods(programid: string) {
  return useQuery({
    queryKey: [...CARE_PERIOD_KEYS.all, 'program-complete', programid],
    queryFn: () => CarePeriodService.getProgramPeriods(programid),
    enabled: /^\d+$/.test(programid),
    staleTime: 0,
  });
}

// Imperative one-shot for event-handler reloads (e.g. post-unalignment).
export function useFetchCarePeriodByUser() {
  const qc = useQueryClient();
  return useCallback(
    (userid: string | number) => qc.fetchQuery({
      queryKey: CARE_PERIOD_KEYS.byUser(userid),
      queryFn: () => CarePeriodService.getCarePeriodByUser(userid),
    }),
    [qc],
  );
}

// Imperative one-shot for event handlers that need the active care_period_id.
export function useFetchActiveCareperiodId() {
  const qc = useQueryClient();
  return useCallback(
    (userid: string | number) => qc.fetchQuery({
      queryKey: CARE_PERIOD_KEYS.activeId(userid),
      queryFn: () => CarePeriodService.getActiveCareperiodId(userid),
    }),
    [qc],
  );
}

export type { CarePeriod };
